import $ from "jquery";

if (document.querySelector(".sliderinformativo")) {

    const cardSliderinfo = document.querySelectorAll(".sliderinformativo");

    cardSliderinfo.forEach(cardSlider => {
        $(cardSlider).slick({
            dots: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            autoplay: true,
            responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }, {
                breakpoint: 769,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },]

        });
    });
}
